import { fromEvent } from 'rxjs'
import { filter } from 'rxjs/operators'
import { setLockColor, setLogoDark, setLogoLight, updateScroll as updateLogo } from './logo'

let el
let navBtn
let hamburger
let nav
let firstNavLink
let elementsList

let ignoreFocus
let scrollOffset
let mediaQuery = '(min-width: 64em)'
let logoMediaQuery = '(min-width: 48em)'

let animationFrame = null

export function Header() {
    el = document.querySelector('.js-header')
    if (!el) {
        return
    }

    navBtn = el.querySelector('.js-nav-btn')
    hamburger = el.querySelector('.js-nav-btn-hamburger')
    nav = el.querySelector('.js-nav')
    firstNavLink = nav.querySelector('a')

    const hero = document.querySelector('.js-hero')
    if (hero && hero.dataset.size === 'narrow') {
        scrollOffset = hero.offsetHeight - el.offsetHeight - 40
    } else {
        scrollOffset = window.innerHeight * 0.9 - el.offsetHeight - 40
    }

    elementsList = [nav, navBtn, hamburger]

    fromEvent(navBtn, 'click').subscribe(toggleNav)
    fromEvent(document, 'keydown')
        .pipe(filter((evt) => evt.key === 'Escape'))
        .subscribe(closeNav)

    const HeaderClick = fromEvent(el, 'click')

    HeaderClick.pipe(
        filter((evt) => evt.target.classList.contains('js-header-open-sub-nav'))
    ).subscribe((evt) => {
        if (window.matchMedia(mediaQuery).matches) {
            toggleSubNav(evt)
        } else {
            openSubnav(evt)
        }
    })

    HeaderClick.pipe(
        filter((evt) => evt.target.classList.contains('js-header-close-sub-nav'))
    ).subscribe(closeSubnav)

    fromEvent(document, 'focusin').subscribe((evt) => {
        if (ignoreFocus) {
            ignoreFocus = false
            return
        }

        if (evt.target.closest('.js-header-sub-nav-container')) {
            el.classList.add('subnav-open')
        } else {
            el.classList.remove('subnav-open')
        }

        if (window.matchMedia(mediaQuery).matches) {
            return
        }

        if (nav.dataset.active && !evt.target.closest('.js-header')) {
            closeNav()
        } else if (!nav.dataset.active && evt.target.closest('.js-nav')) {
            openNav()
        }
    })

    scroll()
    window.addEventListener('scroll', () => {
        scroll(scroll)
    })
}

function toggleSubNav(evt) {
    let container = evt.target.closest('.js-header-sub-nav-container')
    if (!container) {
        return
    }

    if (container.dataset.subnavActive) {
        container.removeAttribute('data-subnav-active')
        el.classList.remove('subnav-open')
    } else {
        closeSubnav()
        container.dataset.subnavActive = true
        el.classList.add('subnav-open')
    }
}

function openSubnav(evt) {
    let container = evt.target.closest('.js-header-sub-nav-container')
    if (!container) {
        return
    }

    container.dataset.subnavActive = true
}

function closeSubnav() {
    const openSubnav = el.querySelector('.js-header-sub-nav-container[data-subnav-active]')
    if (openSubnav) {
        openSubnav.removeAttribute('data-subnav-active')
    }
}

function toggleNav() {
    if (nav.dataset.active) {
        closeNav()
    } else {
        openNav()
        firstNavLink.focus()
        ignoreFocus = true
    }
}

function closeNav() {
    if (!nav.dataset.active) {
        return
    }

    closeSubnav()

    elementsList.forEach((el) => {
        el.removeAttribute('data-active')
    })
    navBtn.setAttribute('aria-label', 'Open nav')
    document.body.removeAttribute('data-lock')

    if (window.matchMedia(logoMediaQuery).matches) {
        setLockColor(false)
        updateLogo()
    }
}

function openNav() {
    if (nav.dataset.active) {
        return
    }

    elementsList.forEach((el) => {
        el.dataset.active = true
    })
    navBtn.setAttribute('aria-label', 'Close nav')
    document.body.dataset.lock = true

    if (window.matchMedia(logoMediaQuery).matches) {
        setLockColor(true)
        setLogoLight()
    }
}

function scroll() {
    if (animationFrame) {
        return
    }

    animationFrame = requestAnimationFrame(() => {
        let currentScroll = window.scrollY

        if (currentScroll > scrollOffset) {
            el.dataset.hideNav = true

            if (!window.matchMedia(logoMediaQuery).matches) {
                setLogoDark()
            }
        } else {
            el.removeAttribute('data-hide-nav')

            if (!window.matchMedia(logoMediaQuery).matches) {
                setLogoLight()
            }
        }
        animationFrame = null
    })
}
